import { Dispatch, SetStateAction, useEffect, useState } from 'react'
import { useIntl } from 'react-intl'
import { InfoCard2 } from '../../../widgets/components/UI/InfoCard2'
import { SelectInput } from '../../../widgets/components/Input/SelectInput'
import { Field, Form, Formik } from 'formik'
import TextInput from '../../../widgets/components/Input/TextInput'
import TextArea from '../../../widgets/components/Input/TextArea'
import { Link, useLocation, useNavigate } from 'react-router-dom'
import { useModuleStatus } from '../../../../hooks/useModuleStatus'
import RectangularTabs from '../../../widgets/components/RectangularTabs'
import {
  complianceSubCategory,
  createMeeting,
  getMeetings,
  updateMeetings,
} from '../../core/_requests'
import { reminderBeforeMeetingOptions, reminderOptions } from '../../core/_constants'
import * as Yup from 'yup'
import { toast } from 'react-toastify'
import { useAuth } from '../../../auth'
import { ToolTipUIForModal } from '../../../widgets/components/UI/ToolTipUIForModal'
import { getDaysDifference, isPastMeeting, reminderBeforeMeetingTime } from '../../core/_util'
import Skeleton from 'react-loading-skeleton'
import TagManager from 'react-gtm-module'
import { GTMEvent } from '../../../../hooks/gtmHelpers'
import brandingConfig from '../../../../../config/brandingConfig'
export default function Schedule({
  setSidebar,
  meetingCategory,
  setMeetingId,
  meetingId,
  setMeetingType,
}: {
  setSidebar: Dispatch<SetStateAction<number>>
  meetingCategory: string
  setMeetingId: Dispatch<SetStateAction<string>>
  meetingId: string
  setMeetingType: Dispatch<SetStateAction<string>>
}) {
  const { formatMessage } = useIntl()
  const location = useLocation()
  const { companyId, currentUser } = useAuth()
  const navigate = useNavigate() // Get the navigate function
  const { moduleStatus } = useModuleStatus()
  const [editMeetingData, setEditMeetingData] = useState<any>()
  const [loading, setLoading] = useState(false)
  const [isLoading, setIsLoading] = useState(false)
  const timeFormat = localStorage.getItem('timeZone')
  const getMeetingDetails = async () => {
    setIsLoading(true)
    try {
      const {
        data: { success, data },
      } = await getMeetings(meetingId)

      if (success) {
        setEditMeetingData(data)
        setMeetingType(data.type)
      }
    } catch (err) {
      console.log(err)
    } finally {
      setIsLoading(false)
    }
  }
  useEffect(() => {
    if (meetingId) getMeetingDetails()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps
  const [subCategory, setSubCategory] = useState([])
  const options = [
    {
      id: 1,
      title: formatMessage({ id: 'Physical Meeting w/ Link' }),
      subTitle: formatMessage({
        id: 'Physical meeting with optional link from tools like Zoom, Team, Meet, etc.',
      }),
      slug: 'physical-meeting-w/-link',
    },
    {
      id: 2,
      title: formatMessage({ id: 'Virtual Meeting' }),
      subTitle: formatMessage({
        id: 'Meeting to be conducted virtually only with Tools like Zoom, Team, Meet, etc.',
      }),
      slug: 'virtual-meeting',
    },
  ]
  const filteredOptions =
    moduleStatus['stakeholder'] !== false
      ? options
      : options.filter((option) => ![2].includes(option.id))
  const [selectedTab, setSelectedTab] = useState<number>(1)
  const [meetingType, setMeetType] = useState<string>('Physical Meeting')
  const handleTabChange = (id: number) => {
    setSelectedTab(id)
    const selectedOption = options.find((option) => option.id === id)
    if (selectedOption) {
      setMeetType(selectedOption.title)
      setMeetingType(selectedOption.title)
      navigate(
        `${location.pathname}?tab=${selectedOption.slug.toLowerCase()}${meetingId ? `&meetingId=${meetingId}` : ''
        }`
      )
    }
  }

  useEffect(() => {
    const handleTabChange = () => {
      navigate(
        `${location.pathname}?tab=${options[0].slug}${meetingId ? `&meetingId=${meetingId}` : ''}`
      )
    }
    if (editMeetingData) {
      const selectedOption = options.find((option) => option.title.includes(editMeetingData?.type))
      if (selectedOption) {
        setSelectedTab(selectedOption.id)
        setMeetType(selectedOption.title)
        setMeetingType(selectedOption.title)
        navigate(
          `${location.pathname}?tab=${selectedOption.slug.toLowerCase()}${meetingId ? `&meetingId=${meetingId}` : ''
          }`
        )
      }
    } else handleTabChange()
  }, [editMeetingData]) // eslint-disable-line react-hooks/exhaustive-deps
  const getMeetingCategory = async () => {
    try {
      const {
        data: { success, data },
      } = await complianceSubCategory()

      if (success && data.complianceSubCategory) {
        const value = data.complianceSubCategory.map((subCategory: any) => {
          return {
            id: subCategory.subCategoryId,
            name: subCategory.subCategoryTitle,
            value: subCategory.subCategoryId,
          }
        })
        setSubCategory(value)
      }
    } catch (err) {
      console.log(err)
    }
  }

  useEffect(() => {
    getMeetingCategory()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps
  const userSchema = Yup.object().shape({
    meetingTitle: Yup.string()
      .required('Meeting title is required')
      .min(3, 'Meeting title should be at least 3 characters')
      .max(100, 'Meeting title cannot exceed 100 characters'),

    subCategory: Yup.number().required('Meeting sub category is required'),

    venue: Yup.string().when('selectedTab', {
      is: 1,
      then: Yup.string().required('Meeting venue is required'),
    }),

    link: Yup.string().url('Invalid url').required('Meeting link is required'),

    allDay: Yup.bool().required('Meeting date is required'),
    meetingDate: Yup.string().required('Meeting date is required'),
    startTime: Yup.string().when('allDay', {
      is: false,
      then: Yup.string().required('Meeting start time is required'),
    }),
    endTime: Yup.string().when('selectedTab', {
      is: false,
      then: Yup.string().required('Meeting end time is required'),
    }),
    notes: Yup.string().nullable().max(500, 'Meeting notes cannot exceed 500 characters'),

    description: Yup.string()
      .required('Meeting description is required')
      .max(1000, 'Meeting description cannot exceed 1000 characters'),

    firstReminder: Yup.string().nullable(),

    secondReminder: Yup.string().nullable(),

    thirdReminder: Yup.string().nullable(),

    finalReminder: Yup.string().nullable(),

    reminderBeforeMeeting: Yup.string().nullable(),
  })

  const initialValues = {
    meetingTitle: editMeetingData ? editMeetingData.meetingTitle : '',
    subCategory: editMeetingData ? editMeetingData.meetingSubCategory.subCategoryId : 1,
    venue: editMeetingData ? editMeetingData.venue : '',
    link: editMeetingData ? editMeetingData.link : '',
    allDay: editMeetingData ? editMeetingData.allDay : false,
    meetingDate: editMeetingData ? editMeetingData.meetingDate : '',
    startTime: editMeetingData ? editMeetingData.startTime : '',
    endTime: editMeetingData ? editMeetingData.endTime : '',
    notes: editMeetingData ? editMeetingData.notes : '',
    description: editMeetingData ? editMeetingData.description : '',
    firstReminder:
      editMeetingData && editMeetingData.meetingReminders.length > 0
        ? editMeetingData.meetingReminders.find((r: any) => r.reminderType === 'firstReminder')
          .reminderValue
        : 'No Reminder',
    secondReminder:
      editMeetingData && editMeetingData.meetingReminders.length > 0
        ? editMeetingData.meetingReminders.find((r: any) => r.reminderType === 'secondReminder')
          .reminderValue
        : 'No Reminder',
    thirdReminder:
      editMeetingData && editMeetingData.meetingReminders.length > 0
        ? editMeetingData.meetingReminders.find((r: any) => r.reminderType === 'thirdReminder')
          .reminderValue
        : 'No Reminder',
    finalReminder:
      editMeetingData && editMeetingData.meetingReminders.length > 0
        ? editMeetingData.meetingReminders.find((r: any) => r.reminderType === 'finalReminder')
          .reminderValue
        : 'No Reminder',
    reminderBeforeMeeting:
      editMeetingData && editMeetingData.meetingReminders.length > 0
        ? editMeetingData.meetingReminders.find((r: any) => r.reminderType === 'beforeMeeting')
          .reminderValue
        : 'No Reminder',
  }

  const handleSubmit = async (values: any) => {
    const payload = {
      ...values,
      type: meetingType === 'Virtual Meeting' ? 'Virtual Meeting' : 'Physical Meeting',
      category: meetingCategory,
      subCategory: parseInt(values.subCategory),
    }
    if (values.allDay) {
      payload.startTime = '10:00'
      payload.endTime = '23:59'
    }
    const isPast = isPastMeeting(payload.meetingDate, payload.startTime)
    if (isPast) {
      toast.error('Please select a future start time')
      return
    }
    try {
      setLoading(true)
      const {
        data: { success, data, error },
      } = await createMeeting(payload, companyId)
      if (success) {
        setMeetingId(data.meetingId)
        toast.success(formatMessage({ id: 'Meeting scheduled successfully' }))
        setLoading(false)
        setSidebar(3)
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.CreateBoardMeetingInitiationSuccessful,
            action: 'normal',
            metadata: {
              company_id: companyId,
              user_id: currentUser?.userId,
              email: currentUser?.email,
              meeting_detail: payload,
            },
          },
        })
      } else {
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.CreateBoardMeetingInitiationFailed,
            action: 'normal',
            metadata: {
              company_id: companyId,
              user_id: currentUser?.userId,
              email: currentUser?.email,
              meeting_detail: payload,
              error: error[0],
            },
          },
        })
      }
    } catch (e) {
      TagManager.dataLayer({
        dataLayer: {
          event: GTMEvent.CreateBoardMeetingInitiationFailed,
          action: 'normal',
          metadata: {
            company_id: companyId,
            user_id: currentUser?.userId,
            email: currentUser?.email,
            meeting_detail: payload,
            error: e,
          },
        },
      })
    } finally {
      setLoading(false)
    }
  }
  const handleUpdateSubmit = async (formik: any) => {
    if (
      formik.dirty || meetingType === 'Virtual Meeting'
        ? 'Virtual Meeting'
        : 'Physical Meeting' !== editMeetingData.type ||
        meetingCategory !== editMeetingData.category
    ) {
      const dirtyFields = Object.keys(formik.values).filter(
        (key) => formik.values[key] !== formik.initialValues[key]
      )
      const payload = dirtyFields.reduce((acc: any, key: any) => {
        acc[key] = formik.values[key]
        return acc
      }, {})
      const hasDirtyFileIds = formik.values.allDay && dirtyFields.includes('allDay')
      if (hasDirtyFileIds) {
        payload.startTime = '10:00'
        payload.endTime = '23:59'
      }
      if (meetingType !== editMeetingData.type)
        payload.type = meetingType === 'Virtual Meeting' ? 'Virtual Meeting' : 'Physical Meeting'
      if (meetingCategory !== editMeetingData.category) payload.category = meetingCategory
      setLoading(true)
      try {
        const {
          data: { success, error },
        } = await updateMeetings(payload, editMeetingData.meetingId)
        if (success) {
          toast.success(formatMessage({ id: 'Meeting updated successfully.' }))
          setSidebar(3)
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.UpdateBoardMeetingInitiationSuccessful,
              action: 'normal',
              metadata: {
                company_id: companyId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                meeting_detail: payload,
                meeting_id: editMeetingData.meetingId,
              },
            },
          })
        } else {
          TagManager.dataLayer({
            dataLayer: {
              event: GTMEvent.UpdateBoardMeetingInitiationFailed,
              action: 'normal',
              metadata: {
                company_id: companyId,
                user_id: currentUser?.userId,
                email: currentUser?.email,
                meeting_detail: payload,
                meeting_id: editMeetingData.meetingId,
                error: error[0],
              },
            },
          })
        }
      } catch (e) {
        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.UpdateBoardMeetingInitiationFailed,
            action: 'normal',
            metadata: {
              company_id: companyId,
              user_id: currentUser?.userId,
              email: currentUser?.email,
              meeting_detail: payload,
              meeting_id: editMeetingData.meetingId,
              error: e,
            },
          },
        })
      } finally {
        setLoading(false)
      }
    } else {
      setSidebar(3)
    }
  }
  return (
    <>
      <p className='mb-4'>{formatMessage({ id: 'Select type of Meeting' })}</p>

      {meetingType === 'Virtual Meeting' ? (
        <InfoCard2
          title={formatMessage({ id: 'How to Schedule Virtual Compliance Meetings?' })}
          desc={formatMessage({
            id: `Schedule virtual compliance meetings with board members and stakeholders on ${brandingConfig.brandName} by adding scheduling details, managing participants, setting the agenda, and reviewing the details. This feature ensures organized and efficient compliance management.`,
          })}
          slug={brandingConfig.helpLinks.complianceMeetingScheduleNewMeetingVirtual}
        />
      ) : (
        <InfoCard2
          title={formatMessage({ id: 'How to Schedule Physical Compliance Meetings?' })}
          desc={formatMessage({
            id: `Schedule physical compliance meetings with board members and stakeholders on ${brandingConfig.brandName} by adding venue and scheduling details, inviting attendees, setting the agenda, and reviewing the details. This feature ensures organized and efficient compliance management.`,
          })}
          slug={brandingConfig.helpLinks.complianceMeetingScheduleNewMeetingPhysical}
        />
      )}

      <RectangularTabs
        options={filteredOptions}
        selectedTab={selectedTab}
        handleTabChange={handleTabChange}
        isDisabled={editMeetingData && editMeetingData.type && editMeetingData.schedule}
      />

      <div className='w-100 mt-4'>
        {isLoading ? (
          <>
            <div className='mt-md-8 w-100 px-5 px-md-0 mb-4'>
              <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                <div className='col-md-5 mb-10 mb-md-0'>
                  <div className='w-50'>
                    <Skeleton
                      height={20}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                  <div className='mt-2'>
                    <Skeleton
                      height={30}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                </div>
                <div className='col-md-5'>
                  <div className='w-50'>
                    <Skeleton
                      height={20}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                  <div className='mt-2'>
                    <Skeleton
                      height={30}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                </div>
              </div>
              <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                <div className='col-md-5 mb-10 mb-md-0'>
                  <div className='w-50'>
                    <Skeleton
                      height={20}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                  <div className='mt-2'>
                    <Skeleton
                      height={30}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                </div>
                <div className='col-md-5'>
                  <div className='w-50'>
                    <Skeleton
                      height={20}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                  <div className='mt-2'>
                    <Skeleton
                      height={30}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                </div>
              </div>
              <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                <div className='col-md-5 mb-10 mb-md-0'>
                  <div className='w-50'>
                    <Skeleton
                      height={20}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                  <div className='mt-2'>
                    <Skeleton
                      height={30}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                </div>
                <div className='col-md-5'>
                  <div className='w-50'>
                    <Skeleton
                      height={20}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                  <div className='mt-2'>
                    <Skeleton
                      height={30}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                </div>
                <div className='col-md-5'>
                  <div className='w-50'>
                    <Skeleton
                      height={20}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                  <div className='mt-2'>
                    <Skeleton
                      height={100}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                </div>
                <div className='col-md-5'>
                  <div className='w-50'>
                    <Skeleton
                      height={20}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                  <div className='mt-2'>
                    <Skeleton
                      height={100}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                </div>
              </div>
              <div className='d-md-flex col-md-12 flex-wrap gap-6 mb-10'>
                <div className='col-md-5 mb-10 mb-md-0'>
                  <div className='w-50'>
                    <Skeleton
                      height={20}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                  <div className='mt-2'>
                    <Skeleton
                      height={30}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                </div>
                <div className='col-md-5'>
                  <div className='w-50'>
                    <Skeleton
                      height={20}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                  <div className='mt-2'>
                    <Skeleton
                      height={30}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                </div>
                <div className='col-md-5'>
                  <div className='w-50'>
                    <Skeleton
                      height={20}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                  <div className='mt-2'>
                    <Skeleton
                      height={30}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                </div>
                <div className='col-md-5'>
                  <div className='w-50'>
                    <Skeleton
                      height={20}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                  <div className='mt-2'>
                    <Skeleton
                      height={30}
                      baseColor='var(--kt-skeleton-bg-color)'
                      highlightColor='var(--kt-skeleton-highlight-bg-color)'
                    />
                  </div>
                </div>
              </div>
            </div>
          </>
        ) : (
          <div className='w-100'>
            <Formik
              initialValues={initialValues}
              validationSchema={userSchema}
              onSubmit={editMeetingData ? handleUpdateSubmit : handleSubmit}
              enableReinitialize={true}
              validateOnMount
            >
              {(formik) => {
                return (
                  <Form>
                    <div className='row'>
                      <div className='col-md-6 col-12'>
                        <TextInput
                          fieldType='text'
                          label={formatMessage({ id: 'Meeting Title' })}
                          fieldName='meetingTitle'
                          formik={formik}
                          placeholder={formatMessage({ id: 'Enter meeting title' })}
                          toolTipText={formatMessage({
                            id: 'Provide a title of the Compliance Meeting here to be scheduled physically.',
                          })}
                          onBlur={formik.handleBlur}
                          isStarRequired={true}
                          isTooltipForModal={true}
                        />
                      </div>
                      <div className='col-md-6 col-12'>
                        <SelectInput
                          label={formatMessage({ id: 'Meeting Sub Category' })}
                          fieldName='subCategory'
                          placeholder={formatMessage({ id: 'Annual General Meeting' })}
                          formik={formik}
                          toolTipText={formatMessage({
                            id: 'Select the type of Board Meeting that describes its nature.',
                          })}
                          options={subCategory}
                          isTooltipForModal={true}
                          isStarRequired
                        />
                      </div>
                      {selectedTab === 1 && (
                        <div className='col-md-6 col-12'>
                          <TextInput
                            fieldType='text'
                            label={formatMessage({ id: 'Meeting Venue' })}
                            fieldName='venue'
                            formik={formik}
                            placeholder={formatMessage({ id: 'Enter meeting Venue' })}
                            toolTipText={formatMessage({
                              id: 'Provide the venue details where the meeting is to be held.',
                            })}
                            onBlur={formik.handleBlur}
                            isStarRequired={true}
                            isTooltipForModal={true}
                          />
                        </div>
                      )}
                      <div className='col-md-6 col-12'>
                        <TextInput
                          fieldType='text'
                          label={formatMessage({ id: 'Meeting Link' })}
                          fieldName='link'
                          formik={formik}
                          placeholder={formatMessage({ id: 'Enter meeting link' })}
                          toolTipText={formatMessage({
                            id: 'Provide a link to attend the meeting virtually as an option to the participants.',
                          })}
                          onBlur={formik.handleBlur}
                          isStarRequired={true}
                          isTooltipForModal={true}
                        />
                      </div>
                      <div className='col-md-12 col-12 mb-8'>
                        <div>
                          <TextInput
                            fieldName={'allDay'}
                            label={formatMessage({ id: 'Meeting Time' })}
                            formik={formik}
                            customText={formatMessage({ id: 'All day' })}
                            placeholder=''
                            fieldType={'checkbox'}
                            isCheckbox={true}
                            isStarRequired={true}
                            isWidthNotRequired={true}
                            isTooltipNotRequired={true}
                            margin='mb-n2'
                          />
                        </div>
                        <div className='d-flex w-100'>
                          <div className='d-flex flex-md-row flex-column flex-end mb-8 gap-2'>
                            <TextInput
                              fieldType='date'
                              fieldName='meetingDate'
                              formik={formik}
                              placeholder={formatMessage({ id: 'Enter meeting date' })}
                              toolTipText={formatMessage({
                                id: 'Select the date and time for the meeting to be scheduled.',
                              })}
                              isWidthNotRequired={true}
                              isTooltipNotRequired={true}
                              isDateField
                              margin='mb-n2'
                            />

                            {formik.values.allDay === false && (
                              <>
                                <div className='w-100 w-md-50'>
                                  <TextInput
                                    fieldType='time'
                                    fieldName='startTime'
                                    formik={formik}
                                    placeholder={formatMessage({ id: 'Enter meeting start time' })}
                                    isTooltipNotRequired={true}
                                    isWidthNotRequired={true}
                                    margin='mb-n2'
                                  />
                                </div>
                                <div className='w-100 w-md-50'>
                                  <TextInput
                                    fieldType='time'
                                    fieldName='endTime'
                                    formik={formik}
                                    placeholder={formatMessage({ id: 'Enter meeting end time' })}
                                    isTooltipNotRequired={true}
                                    isWidthNotRequired={true}
                                    margin='mb-n2'
                                  />
                                </div>
                              </>
                            )}
                          </div>
                        </div>
                      </div>
                      <div
                        className='d-flex flex-column mt-n8 mb-8'
                        style={{ width: '-webkit-fill-available' }}
                      >
                        <p
                          style={{
                            fontFamily: 'Poppins',
                            fontWeight: '400',
                            fontSize: '13px',
                            lineHeight: '20px',
                          }}
                        >
                          {timeFormat &&
                            formatMessage({
                              id: `Your current Timezone is ${timeFormat}. `,
                            })}
                          <span style={{ color: '#4776E6' }}>
                            <Link to='/setting/user-settings?tab=locale'>
                              {formatMessage({ id: 'Click here' })}{' '}
                            </Link>
                          </span>
                          {formatMessage({ id: 'To change timezone.' })}
                        </p>
                      </div>
                      <div className='col-md-6 col-12'>
                        <TextArea
                          label={formatMessage({ id: 'Meeting notes (For Internal use only)' })}
                          fieldName='notes'
                          formik={formik}
                          placeholder={formatMessage({ id: 'Meeting notes' })}
                          toolTipText={formatMessage({
                            id: `Mention important meeting notes for the internal team's reference. These notes would not visible to others.`,
                          })}
                          isTooltipForModal={true}
                          onBlur={formik.handleBlur}
                        />
                      </div>
                      <div className='col-md-6 col-12'>
                        <TextArea
                          label={formatMessage({
                            id: 'Meeting description (Will be available to all participants)',
                          })}
                          fieldName='description'
                          formik={formik}
                          placeholder={formatMessage({ id: 'Meeting description' })}
                          toolTipText={formatMessage({
                            id: 'Provide meeting description that informs the participants about the meting agenda. This information will be public to all the attendees.',
                          })}
                          onBlur={formik.handleBlur}
                          isStarRequired={true}
                          isTooltipForModal={true}
                        />
                      </div>
                      <div className='col-md-6 col-12 mb-8'>
                        <label className='d-flex form-label font-size-13 text-dark text-capitalize ms-0 ms-md-0'>
                          {formatMessage({ id: 'Send First Reminder' })}{' '}
                          <ToolTipUIForModal
                            tooltipText={formatMessage({
                              id: 'Choose when to send the first reminder of the meeting.',
                            })}
                          />
                        </label>
                        <Field
                          as='select'
                          name='firstReminder'
                          className='form-select h-40px font-size-13'
                        >
                          <option className='text-muted' hidden>
                            {formatMessage({ id: 'Select First Reminder' })}
                          </option>
                          {reminderOptions?.map((option: any, index) => {
                            return (
                              <option
                                key={index}
                                value={option.value}
                                disabled={
                                  (getDaysDifference(formik.values.meetingDate) <
                                    option.value.split(' ')[0] &&
                                    option.value.split(' ')[1] !== 'Week') ||
                                  (option.value.split(' ')[1] === 'Week' &&
                                    getDaysDifference(formik.values.meetingDate) <= 7)
                                }
                              >
                                {option.name}
                              </option>
                            )
                          })}
                        </Field>
                      </div>
                      <div className='col-md-6 col-12 mb-8'>
                        <label className='d-flex form-label font-size-13 text-dark text-capitalize ms-0 ms-md-0'>
                          {formatMessage({ id: 'Send Second Reminder' })}{' '}
                          <ToolTipUIForModal
                            tooltipText={formatMessage({
                              id: 'Choose when to send a second meeting reminder to the participants. You can also choose skip this reminder.',
                            })}
                          />
                        </label>
                        <Field
                          as='select'
                          name='secondReminder'
                          className='form-select h-40px font-size-13'
                        >
                          <option className='text-muted' hidden>
                            {formatMessage({ id: 'Select Second Reminder' })}
                          </option>
                          {reminderOptions?.map((option: any, index) => {
                            const id = reminderOptions.find(
                              (data) => data.value === formik.values.firstReminder
                            )?.id
                            return (
                              <option
                                key={index}
                                value={option.value}
                                disabled={
                                  (getDaysDifference(formik.values.meetingDate) <
                                    option.value.split(' ')[0] &&
                                    option.value.split(' ')[1] !== 'Week') ||
                                  (option.value.split(' ')[1] === 'Week' &&
                                    getDaysDifference(formik.values.meetingDate) < 7) ||
                                  (formik.values.firstReminder && id && id >= option.id)
                                }
                              >
                                {option.name}
                              </option>
                            )
                          })}
                        </Field>
                      </div>
                      <div className='col-md-6 col-12 mb-8'>
                        <label className='d-flex form-label font-size-13 text-dark text-capitalize ms-0 ms-md-0'>
                          {formatMessage({ id: 'Send Third Reminder' })}{' '}
                          <ToolTipUIForModal
                            tooltipText={formatMessage({
                              id: 'Choose when to send a third meeting reminder to the participants. You can also choose skip this reminder.',
                            })}
                          />
                        </label>
                        <Field
                          as='select'
                          name='thirdReminder'
                          className='form-select h-40px font-size-13'
                        >
                          <option className='text-muted' hidden>
                            {formatMessage({ id: 'Send Third Reminder' })}
                          </option>
                          {reminderOptions?.map((option: any, index) => {
                            const id = reminderOptions.find(
                              (data) => data.value === formik.values.secondReminder
                            )?.id
                            return (
                              <option
                                key={index}
                                value={option.value}
                                disabled={
                                  (getDaysDifference(formik.values.meetingDate) <
                                    option.value.split(' ')[0] &&
                                    option.value.split(' ')[1] !== 'Week') ||
                                  (option.value.split(' ')[1] === 'Week' &&
                                    getDaysDifference(formik.values.meetingDate) < 7) ||
                                  (formik.values.secondReminder && id && id >= option.id)
                                }
                              >
                                {option.name}
                              </option>
                            )
                          })}
                        </Field>
                      </div>
                      <div className='col-md-6 col-12 mb-8'>
                        <label className='d-flex form-label font-size-13 text-dark text-capitalize ms-0 ms-md-0'>
                          {formatMessage({ id: 'Send Final Reminder' })}{' '}
                          <ToolTipUIForModal
                            tooltipText={formatMessage({
                              id: 'Choose when to send the last and final reminder to the meeting to all the participants.',
                            })}
                          />
                        </label>
                        <Field
                          as='select'
                          name='finalReminder'
                          className='form-select h-40px font-size-13'
                        >
                          <option className='text-muted' hidden>
                            {formatMessage({ id: 'Send Final Reminder' })}
                          </option>
                          {reminderOptions?.map((option: any, index) => {
                            const id = reminderOptions.find(
                              (data) => data.value === formik.values.thirdReminder
                            )?.id
                            return (
                              <option
                                key={index}
                                value={option.value}
                                disabled={
                                  (getDaysDifference(formik.values.meetingDate) <
                                    option.value.split(' ')[0] &&
                                    option.value.split(' ')[1] !== 'Week') ||
                                  (option.value.split(' ')[1] === 'Week' &&
                                    getDaysDifference(formik.values.meetingDate) < 7) ||
                                  (formik.values.thirdReminder && id && id >= option.id)
                                }
                              >
                                {option.name}
                              </option>
                            )
                          })}
                        </Field>
                      </div>
                      <div className='col-md-6 col-12 mb-8'>
                        <label className='d-flex form-label font-size-13 text-dark text-capitalize ms-0 ms-md-0'>
                          {formatMessage({ id: 'Reminder Just Before Meeting' })}{' '}
                          <ToolTipUIForModal
                            tooltipText={formatMessage({
                              id: 'Specify the duration when you would like to send the a meeting reminder on the day of the meeting.',
                            })}
                          />
                        </label>
                        <Field
                          as='select'
                          name='reminderBeforeMeeting'
                          className='form-select h-40px font-size-13'
                        >
                          <option className='text-muted' hidden>
                            {formatMessage({ id: 'Select Reminder Just Before Meeting' })}
                          </option>
                          {reminderBeforeMeetingOptions?.map((option: any, index) => (
                            <option
                              key={index}
                              value={option.value}
                              disabled={
                                (reminderBeforeMeetingTime(
                                  formik.values.meetingDate,
                                  formik.values.allDay === true ? '10:00' : formik.values.startTime
                                ) < option.value.split(' ')[0] &&
                                  option.value.split(' ')[1] !== 'Hour') ||
                                (option.value.split(' ')[1] === 'Hour' &&
                                  reminderBeforeMeetingTime(
                                    formik.values.meetingDate,
                                    formik.values.allDay === true
                                      ? '10:00'
                                      : formik.values.startTime
                                  ) < 60)
                              }
                            >
                              {option.name}
                            </option>
                          ))}
                        </Field>
                      </div>
                    </div>
                    {/* Submit and Cancel buttons */}
                    <div className='d-flex flex-md-row flex-column gap-3 justify-content-end'>
                      <button
                        className='btn bg-light custom-button-property text-muted fw-normal py-4 w-100 w-md-auto order-md-1 order-2'
                        style={{ width: '120px' }}
                        type='button'
                        onClick={() => {
                          setSidebar(1)
                        }} // For resetting the form
                      >
                        <span className='indicator-label font-size-13 p-0'>
                          {formatMessage({ id: 'Prev' })}
                        </span>
                      </button>

                      <button
                        className='btn bg-primary custom-button-property text-white fw-normal py-4 w-100 w-md-auto order-md-2 order-1'
                        disabled={loading || !formik.isValid}
                        style={{ width: '120px' }}
                        type='button'
                        onClick={() => {
                          editMeetingData
                            ? handleUpdateSubmit(formik)
                            : handleSubmit(formik.values)
                        }}
                      >
                        <span className='indicator-label font-size-13 p-0'>
                          {loading
                            ? formatMessage({ id: 'Please wait..' })
                            : formatMessage({ id: 'Next' })}
                        </span>
                      </button>
                    </div>
                  </Form>
                )
              }}
            </Formik>
          </div>
        )}
      </div>
    </>
  )
}
